import api from 'api'

type UploadCompanyFilesResponseFile = {
  id: number
  path: string
  type: string
  tempUrl: string
  extra?: Record<string, unknown>
}

type UploadCompanyFilesResponse = {
  files: UploadCompanyFilesResponseFile[]
}

const PDF_FILENAME_PATTERN = /^[A-Za-z0-9_-]+\.pdf$/i

export function assertValidCompanyPdfFiles(files: File[]) {
  if (files.length === 0) {
    throw new Error('Select at least one PDF file')
  }

  const invalid = files.find(
    (file) =>
      !file.name.toLowerCase().endsWith('.pdf') ||
      /\s/.test(file.name) ||
      !PDF_FILENAME_PATTERN.test(file.name)
  )
  if (invalid) {
    throw new Error(
      'PDF filename cannot contain spaces. Use letters, numbers, _, and - only.'
    )
  }
}

export async function uploadCompanyFiles(companyId: number, files: File[]) {
  assertValidCompanyPdfFiles(files)

  const formData = new FormData()
  files.forEach((file) => {
    formData.append('files[]', file)
  })

  const response = await api.post<UploadCompanyFilesResponse>(
    `/admin/company/${companyId}/files`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return response.data
}
